import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CustomDatePipe } from 'src/app/_pipes/custom-date.pipe';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessCyberMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-cyber-metadata/business-cyber-metadata.component.abstract';

@Component({
  selector: 'app-business-cyber-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, CustomDatePipe],
  templateUrl: './business-cyber-metadata-v2.component.html',
})
export class BusinessCyberMetadataV2Component extends BusinessCyberMetadataComponentAbstract {}
